<template>
  <el-dialog :visible.sync="disableRefreshPreview"
    width="50%"
    :close-on-click-modal="true"
    class="dialog_refresh"
    :show-close="false"
    >
    <div class="update-dialog__content">
      <el-row class="refresh">
      <el-col :span="8">
        <img src="/static/logo360tovisit2.png" height="35px">
      </el-col>
      <el-col :span="16">
        <h3 class="mt-0 mb-0">360tovisit has been upgraded!</h3>
        <article class="mt-4 mb-4" v-if="notification.content !== undefined" v-html="notification.content"></article>
        <div>
          <el-button type="primary" @click="refreshPage">
            <span class="mdi mdi-sync"></span> {{ $t('Refresh Page') }}
          </el-button>
        </div>
      </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
import ls from 'local-storage'

export default {
  data () {
    return {
      disableRefreshPreview: false
    }
  },
  props: {
    notification: {
      required: true,
      type: Object
    }
  },
  methods: {
    checkExits () {
      let last_version = ls.get('last_version')
      if (!Object.keys(this.notification).length) {
        this.disableRefreshPreview = false
      } else {
        if (last_version && last_version == this.notification.key_slug) {
          this.disableRefreshPreview = false
        } else if (!last_version && Object.keys(this.notification).length) {
          this.disableRefreshPreview = true
        } else {
          this.disableRefreshPreview = true
        }
      }
    },
    refreshPage () {
      window.location.reload()
      this.disableRefreshPreview = false
      let last_version = ls.get('last_version')
      let key_slug = this.notification.key_slug
      if (!last_version) {
        ls.set('last_version', key_slug)
      } else {
        if (last_version !== key_slug) {
          ls.remove('last_version', true)
          ls.set('last_version', key_slug)
        }
      }
    }
  },
  created () { 
   let that = this
    setTimeout(function () {
      that.checkExits()
    }, 900)
  },
  watch: {
    notification: {
      handler () {
        this.checkExits()
      },
      deep: true
    }
  }
}
</script>
<style>
.dialog_refresh .el-dialog__body{
  padding-top: 0 !important;
  padding-bottom: 20px !important;
}
.dialog_refresh article {
  line-height: 1.4;
  text-align: justify;
}
</style>


// WEBPACK FOOTER //
// src/components/dialogs/NewVersion.vue